<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="intro"> </p>
<p class="H1">INTRODUCTION</p>
<p class="sp1"> </p>
<p class="TNI">There’s a frontier waiting for you, approximately one hundred miles from where you are at this instant.</p>
<p class="TX">It’s the frontier of space, and it extends to infinity.</p>
<p class="TX">But space is only one of the many new frontiers that await us. There are frontiers of time, as well, and frontiers of courage and devotion, fear and hate.</p>
<p class="TX">Here are fourteen stories about new frontiers of space, time, and the human spirit.</p>
<p class="TX">The stories range from the Baghdad of the <span class="ePub-I">Thousand and One Nights</span> to a spaceship heading for a distant star, from the newly liberated Paris near the end of World War II to a lonely vessel drifting in the vast emptiness of the Asteroid Belt. The stories are set on a golf course on the Moon, in the imperial court of an interstellar empire, in the simulations laboratory of a modern high-tech electronics firm.</p>
<p class="TX">The people in these stories include scoundrels and heroes, scientists and engineers, explorers and innovators, a teenaged Albert Einstein, a dying emperor, and a pope. Each of them stands at a new frontier and must find the heart and strength to cross into new, unexplored territory.</p>
<p class="TX">For human courage and passion are the common denominators of every story, no matter where or when in the universe the tale may be set.</p>
<p class="TX">So please enjoy your travels through these new frontiers of space, time, and the intricacies of human passions.</p>
<p class="TXS">Bon voyage.</p>
<p class="AUSIG">Ben Bova</p>
<p class="AUSIG">Naples, Florida</p>
<p class="AUSIG">2013</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?e23b7260